export default [
  {
    path: '/public',
    meta: {
      public: true,
    },
    component: () => import('@/views/public/Layout'),
    children: [
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        component: () => import('@/views/public/PrivacyPolicy'),
        meta: {
          public: true,
        },
      },
      {
        path: 'terms-and-conditions',
        name: 'terms-and-conditions',
        component: () => import('@/views/public/TermsAndConditions'),
        meta: {
          public: true,
        },
      },
    ],
  },
];
